import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';

import { RcDropdown, RcDropdownItem, RcDropdownTrigger, RcDropdownSeparator } from '@components/RcDropdown';
import IconOrSvg from '@shell/components/IconOrSvg';
import { useI18n } from '@shell/composables/useI18n';
import type { TableViewAction } from '@shell/types/table-views';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableSelectionActions',
  props: {
    actions: { default: () => [] },
    count: { default: 0 },
    actionTooltip: { default: null },
    testid: { default: 'sortable-table' }
  },
  emits: ["click", "mouseover", "mouseleave"],
  setup(__props: any, { emit: __emit }) {

/** The bulk actions for the selected rows, as one "N Selected" menu */
const props = __props;

const emit = __emit;

const { t } = useI18n(useStore());

const deleteAction = computed<TableViewAction | null>(() => props.actions.find((act) => act.action === 'promptRemove') ||
  props.actions.find((act) => (!!act.icon && `${ act.icon }`.includes('icon-trash')) || /delete|remove/i.test(act.action || '')) ||
  null);

const menuActions = computed<TableViewAction[]>(() => {
  const del = deleteAction.value;

  return props.actions.filter((act) => !del || act.action !== del.action);
});

const apply = (act: TableViewAction, event: MouseEvent) => emit('click', act, null, event);

return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return (__props.count)
    ? (_openBlock(), _createBlock(_unref(RcDropdown), {
        key: 0,
        distance: 4,
        placement: "bottom-start"
      }, {
        dropdownCollection: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuActions.value, (act, i) => {
            return _withDirectives((_openBlock(), _createBlock(_unref(RcDropdownItem), {
              key: i,
              disabled: !act.enabled,
              "data-testid": `${ __props.testid }-selection-action-${ act.action }`,
              onClick: ($event: any) => (apply(act, $event)),
              onMouseover: ($event: any) => (emit('mouseover', act)),
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (emit('mouseleave', null)))
            }, {
              before: _withCtx(() => [
                (act.icon || act.svg)
                  ? (_openBlock(), _createBlock(_unref(IconOrSvg), {
                      key: 0,
                      icon: act.icon,
                      src: act.svg,
                      class: "icon"
                    }, null, 8, ["icon", "src"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createTextVNode()),
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_clean_html, act.label]
                ])
              ]),
              _: 2
            }, 1032, ["disabled", "data-testid", "onClick", "onMouseover"])), [
              [_directive_clean_tooltip, { content: __props.actionTooltip, placement: 'right' }]
            ])
          }), 128)),
          _cache[8] || (_cache[8] = _createTextVNode()),
          (deleteAction.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (menuActions.value.length)
                  ? (_openBlock(), _createBlock(_unref(RcDropdownSeparator), { key: 0 }))
                  : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _withDirectives((_openBlock(), _createBlock(_unref(RcDropdownItem), {
                  disabled: !deleteAction.value.enabled,
                  "data-testid": `${ __props.testid }-selection-action-delete`,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (apply(deleteAction.value, $event))),
                  onMouseover: _cache[2] || (_cache[2] = ($event: any) => (emit('mouseover', deleteAction.value))),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (emit('mouseleave', null)))
                }, {
                  before: _withCtx(() => [
                    _createVNode(_unref(IconOrSvg), {
                      icon: deleteAction.value.icon || 'icon icon-delete',
                      src: deleteAction.value.svg,
                      class: "icon"
                    }, null, 8, ["icon", "src"])
                  ]),
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('tableViews.bulk.deleteSelected')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "data-testid"])), [
                  [_directive_clean_tooltip, { content: __props.actionTooltip, placement: 'right' }]
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(RcDropdownTrigger), {
            variant: "primary",
            size: "medium",
            class: "selection-trigger",
            "data-testid": `${ __props.testid }-selection-actions`
          }, {
            after: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "icon icon-chevron-down" }, null, -1)
            ]))]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('tableViews.bulk.selected', { count: __props.count })) + " ", 1)
            ]),
            _: 1
          }, 8, ["data-testid"]),
          _cache[9] || (_cache[9] = _createTextVNode())
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})